<template>
    <!-- 编辑界面 -->
    <el-drawer :title="title" :visible.sync="editFormVisible" @click="closeDialog" :size="600" :wrapperClosable="false"
        :modal="false" :destroy-on-close="true" class="margin_top_40">
        <el-form label-width="8.75rem" :model="editForm" ref="editForm" :rules="rules">
            <el-form-item label="门店：" prop="storeKeyId">
                <el-select v-model="editForm.storeKeyId" placeholder="请选择门店" filterable size="small" class="input_200px"
                    @change="handleChangeStore">
                    <el-option v-for="item in storeList" :label="item.value" :value="item.keyId"
                        :key="item.keyId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="员工：" prop="userKeyId">
                <el-select v-model="editForm.userKeyId" placeholder="请选择员工" clearable filterable size="small"
                    class="input_200px">
                    <el-option v-for="item in userList" :label="item.value" :value="item.keyId"
                        :key="item.keyId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="岗位：" prop="postName">
                <el-input v-model="editForm.postName" placeholder="请输入岗位名称" clearable size="small"
                    class="input_200px"></el-input>
            </el-form-item>
            <el-form-item label="基础工资" prop="baseSalary">
                <el-input v-model.number="editForm.baseSalary" placeholder="请输入基础工资" min="0" clearable size="small"
                    class="input_200px"></el-input>
            </el-form-item>
           
            <el-form-item label="岗位工资" prop="postWage">
                <el-input v-model.number="editForm.postWage" placeholder="请输入岗位工资" min="0" clearable size="small"
                    class="input_200px"></el-input>
            </el-form-item>
            <el-form-item label="社保补贴" prop="socialSecuritySubsidy">
                <el-input v-model.number="editForm.socialSecuritySubsidy" placeholder="请输入社保补贴" min="0" clearable
                    size="small" class="input_200px"></el-input>
            </el-form-item>
            <el-form-item label="工龄补贴" prop="seniorityPay">
                <el-input v-model.number="editForm.seniorityPay" placeholder="请输入工龄补贴" min="0" clearable size="small"
                    class="input_200px"></el-input>
            </el-form-item>
            <el-form-item label="应出勤天数" prop="requiredAttendance">
                <el-input v-model.number="editForm.requiredAttendance" placeholder="请输入应出勤天数" min="0" clearable
                    size="small" class="input_200px"></el-input>
            </el-form-item>
        </el-form>
        <div class="drawer-footer">
            <el-button size="small" icon="el-icon-check" :loading="loading" class="title"
                @click="submitForm('editForm')">
                保存
            </el-button>
        </div>
    </el-drawer>
</template>

<script>
import {
    SaveUserBaseSalary,
    GetUserBaseSalaryDetail
} from "@/api/salaryApi.js";
import {
    GetUserBindSelectByPermission
} from "@/api/userApi.js";
import {
    GetOrgInfoListByConfig
} from "@/api/organizationalApi.js";
export default {
    data() {
        return {
            title: "",
            loading: false, //是显示加载
            editFormVisible: false, //控制编辑页面显示与隐藏
            editForm: {
                keyId: "",
                storeKeyId: "",
                userKeyId: "",
                postName: "",
                baseSalary: 0,
                perfectAttendance: 0,
                postWage: 0,
                socialSecuritySubsidy: 0,
                seniorityPay: 0,
                requiredAttendance: 0,
            },
            storeList: [],
            // rules 表单验证
            rules: {
                storeKeyId: [
                    {
                        required: true,
                        message: "请选择门店",
                        trigger: "blur",
                    },
                ],
                userKeyId: [
                    {
                        required: true,
                        message: "请选择员工",
                        trigger: "blur",
                    },
                ],
                postName: [
                    {
                        required: true,
                        message: "请输入岗位名称",
                        trigger: "blur",
                    },
                ],
                baseSalary: [
                    {
                        required: true,
                        message: "请输入基础工资",
                        trigger: "blur",
                    },
                    {
                        type: "number",
                        message: "请输入数字",
                        trigger: "blur",
                    },
                ],
                postWage: [
                    {
                        required: true,
                        message: "请输入岗位工资",
                        trigger: "blur",
                    },
                    {
                        type: "number",
                        message: "请输入数字",
                        trigger: "blur",
                    },
                ],
                socialSecuritySubsidy: [
                    {
                        required: true,
                        message: "请输入社保补贴",
                        trigger: "blur",
                    },
                    {
                        type: "number",
                        message: "请输入数字",
                        trigger: "blur",
                    },
                ],
                seniorityPay: [
                    {
                        required: true,
                        message: "请输入工龄补贴",
                        trigger: "blur",
                    },
                    {
                        type: "number",
                        message: "请输入数字",
                        trigger: "blur",
                    },
                ],
                requiredAttendance: [
                    {
                        required: true,
                        message: "请输入应出勤天数",
                        trigger: "blur",
                    },
                    {
                        type: "number",
                        message: "请输入数字",
                        trigger: "blur",
                    },
                ],
            },
            userList: [],
            storeList: [],
        };
    },
    computed: {},
    watch: {},
    created() {
        this.GetOrgInfoListByConfig();
    },
    mounted() { },
    components: {},
    methods: {
        //显示编辑界面
        editShow(row) {
            if (row != undefined && row != "undefined") {
                this.title = "编辑";
                let parmer = {
                    keyId: row.keyId,
                };
                GetUserBaseSalaryDetail(parmer)
                    .then((res) => {
                        if (res.code == 1) {
                            this.editForm = res.data;
                            this.editFormVisible = true;

                            this.GetUserBindSelectByPermission(this.editForm.storeKeyId);
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                    .catch((err) => {
                        this.$message.error("获取基础薪资详情失败!");
                    });
            } else {
                this.title = "新增";
                this.$data.editForm = this.$options.data.call(this).editForm;
                this.editFormVisible = true;
            }
        },
        // 编辑、增加页面保存方法
        submitForm(editData) {
            this.$refs[editData].validate((valid) => {
                if (valid) {
                    SaveUserBaseSalary(this.editForm)
                        .then((res) => {
                            if (res.code == 1) {
                                this.$parent.getListData();
                                this.$message({
                                    type: "success",
                                    message: "基础薪资保存成功！",
                                });
                                this.editFormVisible = false;
                                this.loading = false;
                            } else {
                                this.$message({
                                    type: "info",
                                    message: res.msg,
                                });
                            }
                        })
                        .catch((err) => {
                            this.editFormVisible = false;
                            this.loading = false;
                            this.$message.error("基础薪资保存失败，请稍后再试！");
                        });
                } else {
                    return false;
                }
            });
        },
        // 获取所属门店 
        GetOrgInfoListByConfig() {
            const paramer = {
                key: 1,
            };
            GetOrgInfoListByConfig(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.storeList = [];
                        res.data.forEach((item) => {
                            this.storeList.push({
                                keyId: item.keyId,
                                value: item.name + '【' + item.remark2 + '】',
                            });
                        });
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取门店信息失败!");
                });
        },
        // 获取人员信息绑定下拉框_根据权限
        GetUserBindSelectByPermission(storeKeyId) {
            const paramer = {
                keyId: storeKeyId,
            };
            GetUserBindSelectByPermission(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.userList = [];
                        if (res.code == 1) {
                            this.userList = res.data;
                        } else {
                            this.$message.error(res.msg);
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取人员信息失败!");
                });
        },
        // 关闭编辑、增加弹出框
        closeDialog() {
            this.editFormVisible = false;
            this.$data.editForm = this.$options.data.call(this).editForm;
        },
        // 门店选择改变时触发
        handleChangeStore(val) {
            this.GetUserBindSelectByPermission(val);
        },
    },
};
</script>
<style scoped>
.wip {
    width: 200px !important;
}
</style>